module.exports = __webpack_public_path__ + "img/217.b5337d80.jpg";